import { ICtaDestinationFields } from '@/types/contentful';
import { UrlByEnv } from '../context/PageData';
import { getRedirectByEnv } from './buildWebRegUrl';

export function resolveCtaUrl(fields: Partial<ICtaDestinationFields> = {}) {
  const internalUrl = fields.internalLink?.trim();
  if (typeof internalUrl === 'string' && internalUrl.length > 0) {
    // Normalize accidental "/#anchor" to same-page "#anchor"
    if (internalUrl.startsWith('/#')) return internalUrl.substring(1);
    // Allow same-page anchor links like "#section" to pass through unchanged
    if (internalUrl.startsWith('#')) return internalUrl;
    return internalUrl.startsWith('/') ? internalUrl : `/${internalUrl}`;
  }
  return getRedirectByEnv(fields as unknown as UrlByEnv);
}
